import { render, staticRenderFns } from "./PieChart3.vue?vue&type=template&id=1dca4cc8&"
import script from "./PieChart3.vue?vue&type=script&lang=js&"
export * from "./PieChart3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports